import { render } from "./header.vue?vue&type=template&id=0ecfc5cd"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=0ecfc5cd&lang=css"

import exportComponent from "E:\\ddemo\\zhongxiaoqi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__